'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _manualModelSelectModal = require('./manualModelSelect.modal.html');

var _manualModelSelectModal2 = _interopRequireDefault(_manualModelSelectModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasicDetailsController = function () {
  function BasicDetailsController(authService, enums, lookupService, loadingService, $uibModal, $scope, vehicleTraderManagementService, financeCompaniesManagementService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, BasicDetailsController);
    this.authService = authService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.vehicleTraderManagementService = vehicleTraderManagementService;
    this.financeCompaniesManagementService = financeCompaniesManagementService;

    this.selectOptions = {};
    this.selectDefaults = {};
    this.financeCompanies = [];

    this.brandModels = this.getBrandModels();

    this.initializeLookups();

    this.$scope.$on('vehicleAppraisal:parentFormConfigured', function () {
      _this.reverseLookup();
    });
  }

  (0, _createClass3.default)(BasicDetailsController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var ctrl = this;

      this.lookupService.lookupBrands().then(function (brands) {
        //Remove 'All Brands' item from this list
        brands.shift();

        ctrl.allBrands = brands;

        ctrl.lookupService.lookupBrandModels().then(function (brandModels) {
          ctrl.allBrandModels = brandModels;

          ctrl.initializeVehicleTraders();
          ctrl.initializeEnums();
          ctrl.loadFinanceCompanies();
        });
      });
    }
  }, {
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'MILEAGE_TYPE', propName: 'mileageType' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionType' }, { enumName: 'FUEL_TYPE', propName: 'fuelType' }, { enumName: 'COLOR', propName: 'color' }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
        ctrl.selectOptions[item.propName] = enumsArray;
        ctrl.selectDefaults[item.propName] = enumsArray[0];
        ctrl.updateModelFromSelect(item.propName);
      });

      this.initializeTradeRetail();
    }
  }, {
    key: 'initializeTradeRetail',
    value: function initializeTradeRetail() {
      this.autoSolds = [];
      this.autoSolds.push({ id: null, name: 'Please Select' });
      this.autoSolds.push({ id: 1, name: 'Retail' });
      this.autoSolds.push({ id: 2, name: 'Trade' });
    }
  }, {
    key: 'initializeVehicleTraders',
    value: function initializeVehicleTraders() {
      var _this2 = this;

      var ctrl = this;

      this.vehicleTraderManagementService.list(this.authService.authData.currentLocation.key).then(function (response) {
        _this2.vehicleTraders = response.data.items;
        _this2.vehicleTraders.unshift({ vehicleTraderId: null, name: 'Please Select' });
      });
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: defaultOptionText || 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'updateModelFromSelect',
    value: function updateModelFromSelect(modelProperty) {
      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

      var val = this.selectDefaults[selectDefaultProperty][idProperty];
      eval('this.vehicleAppraisal.vehicle.' + modelProperty + ' = ' + val);
    }
  }, {
    key: 'lookupVehicle',
    value: function lookupVehicle() {
      var ctrl = this;
      var currentMileage = ctrl.vehicleAppraisal.vehicle.mileage;
      var mediaItems = ctrl.vehicleAppraisal.vehicle.mediaItems;
      var autoSold = ctrl.vehicleAppraisal.vehicle.autoSold;

      ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle Information');

      ctrl.lookupService.lookupVehicleByRegNo(ctrl.authService.authData.currentLocation.key, ctrl.vehicleAppraisal.vehicle.vehicleCondition, ctrl.vehicleAppraisal.vehicle.registration).then(function (response) {
        (0, _assign2.default)(ctrl.vehicleAppraisal.vehicle, response.data);
        ctrl.vehicleAppraisal.vehicle.mileage = currentMileage;
        ctrl.vehicleAppraisal.vehicle.entityId = ctrl.authService.authData.currentLocation.key;
        ctrl.vehicleAppraisal.vehicle.autoSold = autoSold;
        ctrl.vehicleAppraisal.vehicle.mediaItems = mediaItems;

        ctrl.loadExtras();
        ctrl.reverseLookup();
        ctrl.onVehicleLookup();
      }).catch(function (err) {
        ctrl.onResetVehicle({ autoSold: ctrl.vehicleAppraisal.vehicle.autoSold });

        ctrl.manualSelect();
      }).finally(function () {
        ctrl.loadingService.hideLoading('vehicleInfo');
      });
    }
  }, {
    key: 'loadExtras',
    value: function loadExtras() {
      var ctrl = this;

      var nctExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'NCT Expiry';
      });
      var taxExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'Tax Expiry Date';
      });
      var prevOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'Previous Owners';
      });
      var ukReg = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'UK Reg';
      });
      var ukOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'UK Previous Owners';
      });

      if (nctExpiry) {
        ctrl.vehicleAppraisal.vehicle.nctExpiry = nctExpiry.value;
      }

      if (taxExpiry) {
        ctrl.vehicleAppraisal.vehicle.taxExpiry = taxExpiry.value;
      }

      if (prevOwners) {
        ctrl.vehicleAppraisal.vehicle.prevOwners = prevOwners.value;
      }

      if (ukReg) {
        ctrl.vehicleAppraisal.vehicle.ukReg = ukReg.value;
      }

      if (ukOwners) {
        ctrl.vehicleAppraisal.vehicle.ukOwners = ukOwners.value;
      }
    }
  }, {
    key: 'reverseLookup',
    value: function reverseLookup() {
      var _this3 = this;

      var make = (0, _lodash.find)(this.allBrands, function (o) {
        return o.brandId === _this3.vehicleAppraisal.vehicle.brandId;
      });
      var model = this.vehicleAppraisal.vehicle.brandModelId ? (0, _lodash.find)(this.allBrandModels, function (o) {
        return o.brandModelId === _this3.vehicleAppraisal.vehicle.brandModelId;
      }) : null;
      var color = (0, _lodash.find)(this.selectOptions.color, function (o) {
        return o.id === _this3.vehicleAppraisal.vehicle.color;
      });
      var transmissionType = (0, _lodash.find)(this.selectOptions.transmissionType, function (o) {
        return o.id === _this3.vehicleAppraisal.vehicle.transmissionType;
      });
      var fuelType = (0, _lodash.find)(this.selectOptions.fuelType, function (o) {
        return o.id === _this3.vehicleAppraisal.vehicle.fuelType;
      });

      this.vehicleAppraisal.vehicle.make = make.name;

      if (model) {
        this.vehicleAppraisal.vehicle.model = make.name + ' ' + model.name;
      }

      if (color) {
        this.vehicleAppraisal.vehicle.colorName = color.name;
      }

      if (transmissionType) {
        this.vehicleAppraisal.vehicle.transmissionTypeName = transmissionType.name;
      }

      if (fuelType) {
        this.vehicleAppraisal.vehicle.fuelTypeName = fuelType.name;
      }

      this.brandModels = this.getBrandModels(this.vehicleAppraisal.vehicle.brandId);
    }
  }, {
    key: 'manualSelect',
    value: function manualSelect() {
      this.$scope.errMsg = '';
      this.selectedBrand = this.allBrands[0];
      this.updateBrandModels();

      this.modalInstance = this.$uibModal.open({
        template: _manualModelSelectModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'cancelManualSelect',
    value: function cancelManualSelect() {
      this.modalInstance.close();
    }
  }, {
    key: 'updateBrandModels',
    value: function updateBrandModels() {
      var _this4 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this4.selectedBrand.brandId;
      });
      this.selectedBrandModel = this.brandModels[0];
    }
  }, {
    key: 'selectModelManually',
    value: function selectModelManually() {
      this.vehicleAppraisal.vehicle.brandId = this.selectedBrand.brandId;
      this.vehicleAppraisal.vehicle.brandModelId = this.selectedBrandModel.brandModelId;

      this.reverseLookup();
      this.cancelManualSelect();
    }
  }, {
    key: 'getBrandModels',
    value: function getBrandModels(brandId) {
      var brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === brandId;
      });

      brandModels.unshift({ brandModelId: null, brandId: brandId, name: 'Please Select' });

      return brandModels;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this5 = this;

      var make = (0, _lodash.find)(this.allBrands, function (o) {
        return o.brandId === _this5.vehicleAppraisal.vehicle.brandId;
      });
      var model = this.vehicleAppraisal.vehicle.brandModelId ? (0, _lodash.find)(this.allBrandModels, function (o) {
        return o.brandModelId === _this5.vehicleAppraisal.vehicle.brandModelId;
      }) : null;

      if (model) {
        this.vehicleAppraisal.vehicle.model = make.name + ' ' + model.name;
      }
    }
  }, {
    key: 'loadFinanceCompanies',
    value: function loadFinanceCompanies() {
      var _this6 = this;

      this.financeCompaniesManagementService.listFinanceCompanies(this.authService.authData.currentLocation.key).then(function (response) {
        _this6.financeCompanies = response.data.items;
        _this6.financeCompanies.unshift({ 'financeCompanyId': null, name: 'Please Select' });
      });
    }
  }]);
  return BasicDetailsController;
}();

exports.default = BasicDetailsController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/basicDetails/basicDetails.controller.js